import { render, staticRenderFns } from "./BroadcastTypeLabel.vue?vue&type=template&id=5694be8d&scoped=true&"
import script from "./BroadcastTypeLabel.vue?vue&type=script&lang=js&"
export * from "./BroadcastTypeLabel.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastTypeLabel.vue?vue&type=style&index=0&id=5694be8d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5694be8d",
  null
  
)

export default component.exports